"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _backbone = _interopRequireDefault(require("backbone"));

var _moment = _interopRequireDefault(require("moment"));

var _underscore = _interopRequireDefault(require("underscore"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LandingCountDownView = _backbone.default.View.extend({
  remove: function remove() {
    clearInterval(this.countdown);
    return _backbone.default.View.prototype.remove.call(this);
  },
  startInterval: function startInterval() {
    this.renderCountdown();
    clearInterval(this.countdown);
    this.countdown = setInterval(_underscore.default.bind(this.renderCountdown, this), 1000);
  },
  renderCountdown: function renderCountdown() {
    var timeZone = this.model.get('timeZone');
    var startTime = this.model.get('startTime');
    var diff = 0;

    if (startTime) {
      diff = _moment.default.tz(startTime.replace('  ', ' '), timeZone).diff((0, _moment.default)().tz(timeZone));
    }

    if (diff > 0) {
      var duration = _moment.default.duration(diff);

      this.updateTime(Math.floor(duration.asDays()), duration.hours(), duration.minutes(), duration.seconds());
    } else {
      this.updateTime();
      clearInterval(this.countdown);
    }
  },
  updateTime: function updateTime(days, hours, minutes, seconds) {
    (0, _jquery.default)(this.$('.count-number')[0]).text(days || 0);
    (0, _jquery.default)(this.$('.count-number')[1]).text(hours || 0);
    (0, _jquery.default)(this.$('.count-number')[2]).text(minutes || 0);
    (0, _jquery.default)(this.$('.count-number')[3]).text(seconds || 0);
  },
  render: function render() {
    this.startInterval();
    return this;
  }
});

var _default = LandingCountDownView;
exports.default = _default;